document.addEventListener("DOMContentLoaded", function () {
  initReveals();
  initContador();
  initGaleriaProducto();
  initVariantes();
});

function initReveals() {
  var els = document.querySelectorAll(".au-reveal");
  if (!els.length) return;
  if (!("IntersectionObserver" in window)) {
    els.forEach(function (el) { el.classList.add("au-visible"); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("au-visible");
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll("[data-au-contador]");
  if (!els.length) return;
  if (!("IntersectionObserver" in window)) return;
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        obs.unobserve(el);
        var fin = parseFloat(el.getAttribute("data-au-contador"));
        if (isNaN(fin)) return;
        var dur = 1400;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var prog = Math.min((ts - inicio) / dur, 1);
          var valor = Math.floor(prog * fin);
          el.textContent = valor.toLocaleString("es-ES");
          if (prog < 1) requestAnimationFrame(paso);
          else el.textContent = fin.toLocaleString("es-ES");
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector("[data-au-galeria]");
  if (!galeria) return;
  var principal = galeria.querySelector("[data-au-imagen-principal]");
  var minis = galeria.querySelectorAll("[data-au-miniatura]");
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener("click", function () {
      var nuevoSrc = mini.getAttribute("data-au-miniatura");
      principal.src = nuevoSrc;
      minis.forEach(function (m) { m.classList.remove("au-miniatura-activa"); });
      mini.classList.add("au-miniatura-activa");
    });
  });
}

function initVariantes() {
  var form = document.querySelector("[data-au-form-producto]");
  if (!form) return;
  var dataEl = form.querySelector("[data-au-variantes-json]");
  var selects = form.querySelectorAll("[data-au-opcion]");
  if (!dataEl || !selects.length) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var inputId = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector("[data-au-precio]");
  var precioCompareEl = document.querySelector("[data-au-precio-compare]");
  var botonComprar = form.querySelector("[data-au-boton-comprar]");

  function opcionesSeleccionadas() {
    var vals = [];
    selects.forEach(function (s) { vals.push(s.value); });
    return vals;
  }

  function actualizar() {
    var sel = opcionesSeleccionadas();
    var encontrada = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === sel[i]; });
    });
    if (!encontrada) return;
    inputId.value = encontrada.id;
    if (precioEl) precioEl.textContent = encontrada.price_formatted;
    if (precioCompareEl) {
      if (encontrada.compare_at_price_formatted) {
        precioCompareEl.textContent = encontrada.compare_at_price_formatted;
        precioCompareEl.style.display = "";
      } else {
        precioCompareEl.style.display = "none";
      }
    }
    if (botonComprar) {
      if (encontrada.available) {
        botonComprar.disabled = false;
        botonComprar.textContent = botonComprar.getAttribute("data-au-texto-disponible");
      } else {
        botonComprar.disabled = true;
        botonComprar.textContent = botonComprar.getAttribute("data-au-texto-agotado");
      }
    }
    if (encontrada.image_url) {
      var principal = document.querySelector("[data-au-imagen-principal]");
      if (principal) principal.src = encontrada.image_url;
      var minis = document.querySelectorAll("[data-au-miniatura]");
      minis.forEach(function (m) {
        if (m.getAttribute("data-au-miniatura") === encontrada.image_url) {
          m.classList.add("au-miniatura-activa");
        } else {
          m.classList.remove("au-miniatura-activa");
        }
      });
    }
  }

  selects.forEach(function (s) { s.addEventListener("change", actualizar); });
}
